<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbWidgets',
  components: {},
}
</script>
